<template>
    <div class="">
        <h1 class="text-muted mb-4">
            <vue-fontawesome class="mr-2" size="2" icon="calculator"></vue-fontawesome>
            Expenses
        </h1>
        <!-- list expenses -->
        <section>
            <div class="d-flex justify-content-between">
                <div>
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" 
                                id="pills-home-tab" 
                                data-toggle="pill" 
                                href="#pills-home" 
                                role="tab" 
                                aria-controls="pills-home" 
                                aria-selected="true">
                                                        
                                Expenses
                            </a>
                        </li>  
                        <li class="nav-item">
                            <a class="nav-link" 
                                id="pills-expense-types-tab" 
                                data-toggle="pill" 
                                href="#pills-expense-types" 
                                role="tab" 
                                aria-controls="pills-expense-types" 
                                aria-selected="true">
                                                        
                                Expenses types
                            </a>
                        </li>                              							
                    </ul>
                </div>               
            </div>	
            <!-- tab view -->
            <div class="tab-content" id="pills-tabContent">
                <!-- expenses -->
                <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                    <div class="d-flex justify-content-between p-2 mb-5 ">
                        <!-- right -->
                        <section class="w-100 d-flex justify-content-between">
                            <div class="d-flex">
                                <span class="p-2 font-weight-bold" v-if="expenses">
                                    <span class="text-muted">Found</span> {{expenses.length}}
                                </span>
                                <div class="dropdown">
                                    <a class="btn btn-light dropdown-toggle" 
                                        href="#" role="button" id="dropdownMenuLink" 
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        filter <vue-fontawesome class="mr-2" icon="filter"></vue-fontawesome>	
                                    </a>
                                    
                                    <div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
                                            <div class="form-group d-flex justify-content-between">
                                                <label class="p-2">Search</label>
                                                <input type="text" class="col-8 form-control" v-model="search"> 
                                            </div> 
                                            <div class="form-group d-flex justify-content-between">
                                                <label >Since</label>
                                                <select class="col-8 form-control" v-model="date_range">
                                                    <option value=1>today</option>
                                                    <option value=2>yesterday</option>
                                                    <option value=7>last 7 days</option>
                                                    <option value=14>last 14 days</option>
                                                    <option value=30>last 30 days</option>
                                                    <option value=90>last 3 months</option>
                                                </select>
                                            </div>														
                                            <div class="form-group d-flex justify-content-between">
                                                <label class="p-2">From</label>
                                                <input type="date" name="bday" max="3000-12-31" 
                                                min="1000-01-01" class="col-8 form-control" v-model="from_date"> 
                                            </div> 
                                            <div class="form-group d-flex justify-content-between">
                                                <label class="p-2">To</label>
                                                <input type="date" name="bday" max="3000-12-31" 
                                                min="1000-01-01" class="col-8 form-control" v-model="to_date"> 
                                            </div> 
                                            <div class="ml-2 d-flex justify-content-end">
                                                <button class="btn btn-outline-success"  @click="getExpenses()">
                                                    Get Expenses
                                                </button>
                                            </div>	                                        
                                    </div>                                
                                </div>
                                <div class="ml-2">
                                    <button class="btn btn-outline-success border-0"
                                        @click="$exportTable('expensesTable','expenses.csv')">  
                                        <vue-fontawesome class="mr-2" icon="file-excel-o"></vue-fontawesome>                              
                                        Export
                                    </button>	
                                </div>	
                            </div>      
                            <div>
                                <button class="btn btn-success"  data-toggle="modal" data-target="#addExpenseModal">
                                    add expense
                                </button>
                            </div>                      
                        </section>  
                        <!-- add buttons -->
                        <section class="d-block d-md-none">
                            <button  type="button" class="btn btn-success" data-toggle="modal" data-target="#addExpenseModal"
                                @click="getExpenseTypes();getLocations()">
                                Add Expense 
                            </button>
                        </section>             																							
                    </div>
                    <!-- TABLE AND DEPENDENCIES -->
                    <div class="rounded shadow border border-light p-2">
                        <table class="table table-borderless" id="expensesTable">
                            <thead >
                                <tr>
                                    <th scope="col">Date</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">Location</th>
                                    <th scope="col">Narration</th>
                                    <th scope="col"></th>                        
                                </tr>
                            </thead>                    
                            <tbody v-if="expenses && expenses.length">
                                <tr v-for="(expense,index) in expenses" :key="index">
                                    <td>{{expense.date | dateformat}}</td>
                                    <td>{{expense.amount}}</td>
                                    <td>{{expense.location_id | location(add_expense.locations)}}</td>
                                    <td>{{expense.narration}}</td>
                                    <div class="p-3">
                                        <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Actions
                                        </a>
                                        <span class="dropdown-menu">                                                                                                                                                                
                                            <a class="dropdown-item" data-toggle="modal" data-target="#editExpenseModal"
                                                @click="getExpenseTypes();selectExpense(expense)">
                                                view expense
                                            </a>
                                            <button class="dropdown-item text-danger" @click="deleteExpense(expense)">delete</button>                                            										                                    
                                        </span>
                                    </div>   
                                </tr>                       
                            </tbody>
                        </table>
                        <div class="p-3 d-flex justify-content-center"
                            v-if="expenses && ! expenses.length">
                            <span class="p-2">No records to show since</span>
                            <div class="form-group d-flex justify-content-between">								
                                <select class="form-control" v-model="date_range">
                                    <option value=1>today</option>
                                    <option value=2>yesterday</option>
                                    <option value=7>last 7 days</option>
                                    <option value=14>last 14 days</option>
                                    <option value=30>last 30 days</option>
                                    <option value=90>last 3 months</option>
                                </select>
                            </div>
                        </div>
                        <div class="p-3 d-flex justify-content-center"
                            v-if="! expenses">
                            <div class="spinner-border p-3 m-5" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>	
                    </div>            	
                </div>
                <!-- expense types -->
                <div class="tab-pane fade" id="pills-expense-types" role="tabpanel" aria-labelledby="pills-expense-types-tab">
                    <div class="d-flex justify-content-between p-2 mb-5">
                            <!-- right -->
                            <section class="d-flex">
                                <span class="p-2 font-weight-bold" v-if="expenses">
                                    <span class="text-muted">Found</span> {{expenses.length}}
                                </span>
                                <div class="dropdown">
                                    <a class="btn btn-light dropdown-toggle" 
                                        href="#" role="button" id="dropdownMenuLink" 
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <vue-fontawesome class="mr-2" icon="filter"></vue-fontawesome>	
                                    </a>
                                    
                                    <div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
                                            <div class="form-group d-flex justify-content-between">
                                                <label class="p-2">Search</label>
                                                <input type="text" class="col-8 form-control" v-model="search"> 
                                            </div> 
                                            <div class="form-group d-flex justify-content-between">
                                                <label >Since</label>
                                                <select class="col-8 form-control" v-model="date_range">
                                                    <option value=1>today</option>
                                                    <option value=2>yesterday</option>
                                                    <option value=7>last 7 days</option>
                                                    <option value=14>last 14 days</option>
                                                    <option value=30>last 30 days</option>
                                                    <option value=90>last 3 months</option>
                                                </select>
                                            </div>														
                                            <div class="form-group d-flex justify-content-between">
                                                <label class="p-2">From</label>
                                                <input type="date" name="bday" max="3000-12-31" 
                                                min="1000-01-01" class="col-8 form-control" v-model="from_date"> 
                                            </div> 
                                            <div class="form-group d-flex justify-content-between">
                                                <label class="p-2">To</label>
                                                <input type="date" name="bday" max="3000-12-31" 
                                                min="1000-01-01" class="col-8 form-control" v-model="to_date"> 
                                            </div> 
                                            <div class="ml-2 d-flex justify-content-end">
                                                <button class="btn btn-outline-success"  @click="getExpenses()">
                                                    Get Expenses
                                                </button>
                                            </div>	
                                    </div>
                                </div>
                                <div class="ml-2">
                                    <button class="btn btn-outline-success border-0"
                                        @click="$exportTable('expensesTypesTable','expenseTypes.csv')">  
                                        <vue-fontawesome class="mr-2" icon="file-excel-o"></vue-fontawesome>                              
                                        Export
                                    </button>	
                                </div>	
                            </section>  
                            <!-- add buttons -->
                            <section>
                                <button  type="button" class="btn btn-success" data-toggle="modal" data-target="#addExpenseTypeModal">
                                    Add Expense type
                                </button>
                            </section>             																							
                    </div>                
                    <!-- TABLE AND DEPENDENCIES -->
                    <div class="rounded shadow border border-light p-2">
                        <table class="table table-borderless" id="expenseTypesTable">
                            <thead >
                                <tr>
                                    <th scope="col">Name</th>                                  
                                    <th scope="col"></th>                        
                                </tr>
                            </thead>                    
                            <tbody v-if="expense_types && expense_types.length">
                                <tr v-for="(type,index) in expense_types" :key="index">
                                    <td>{{type.name}}</td>
                                    <div class="p-3">
                                        <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Actions
                                        </a>
                                        <span class="dropdown-menu">                                                                                            
                                            <button class="dropdown-item text-danger" @click="deleteExpenseType(type)">remove</button>                                            
                                        </span>
                                    </div>   
                                </tr>                       
                            </tbody>
                        </table>
                        <div class="p-3 d-flex justify-content-center"
                            v-if="expense_types && ! expense_types.length">
                            <span class="p-2">No records to show</span>                          
                        </div>
                        <div class="p-3 d-flex justify-content-center"
                            v-if="! expense_types">
                            <div class="spinner-border p-3 m-5" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>	
                    </div>   
                </div>
            </div>
        </section>      
        <!-- MODALS -->
        <section>      
            <!-- add expense types -->                                          
            <div class="modal fade" id="addExpenseTypeModal" tabindex="-1" role="dialog" aria-labelledby="addExpenseTypeModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                    <div class="modal-header border-0">
                        <h5 class="modal-title" id="exampleModalCenterTitle">Add Expense Type</h5>
                        <button type="button" id="closeAddExpenseTypeModal" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form id="addExpenseForm">
                        <div class="modal-body">                    
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">name</label>
                                    <input type="text" class="col-8 form-control" v-model="expense_type_name">
                                </div>                    
                        </div>
                        <div class="modal-footer border-0">                            
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-success"
                                @click="addExpenseType()">                                                        
                                Add expense Type
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding_expense_type"></span>
                            </button>
                        </div>
                    </form>                
                    </div>
                </div>
            </div>

                
        </section>  
        <!-- add expenses -->
        <section>                                                
            <div class="modal fade" id="addExpenseModal" tabindex="-1" role="dialog" aria-labelledby="addExpense" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalCenterTitle">Add Expense</h5>
                    <button type="button" id="closeAddExpenseModal" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form id="addExpenseForm">
                    <div class="modal-body">                    
                            <div class="p-3 d-flex justify-content-between">
                                <label class="font-weight-bold">date</label>
                                <input type="date" class="col-8 form-control" v-model="add_expense.date">
                            </div>                    
                            <div class="p-3 d-flex justify-content-between">
                                <label class="font-weight-bold">amount</label>
                                <input type="number" class="col-8 form-control" v-model="add_expense.amount" required>
                            </div>
                            <div class="p-3 d-flex justify-content-between">
                                <label class="font-weight-bold">type</label>
                                <select class="col-8 form-control" v-model="add_expense.type" required>
                                    <option v-for="(type,index) in add_expense.expense_types" :key="index" :value="type.id">
                                        {{type.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="p-3 d-flex justify-content-between">
                                <label class="font-weight-bold">location</label>
                                <select class="col-8 form-control" v-model="add_expense.location" required>
                                    <option v-for="(location,index) in add_expense.locations" :key="index" :value="location.id">
                                        {{location.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="p-3 d-flex justify-content-between">
                                <label class="font-weight-bold">narration</label>
                                <textarea  rows="3" class="col-8 form-control"></textarea>
                            </div>
                    </div>
                    <div class="modal-footer">                            
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-success"
                            @click="addExpense()">                                                        
                            Add expense
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="add_expense.adding"></span>
                        </button>
                    </div>
                </form>                
                </div>
            </div>
            </div>
        </section>
        <!-- edit expense. -->
        <section>
            <div class="modal fade" id="editExpenseModal" tabindex="-1" role="dialog" aria-labelledby="editExpenseModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" v-if="expense">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalCenterTitle">Expense : ( {{expense.date | dateformat}} )</h5>
                        <button type="button" id="closeAddExpenseModal" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form id="editExpenseForm">
                        <div class="modal-body">                    
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">date</label>
                                    <input type="date" class="col-8 form-control" v-model="expense.date">
                                </div>                    
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">amount</label>
                                    <input type="number" class="col-8 form-control" v-model="expense.amount" required>
                                </div>
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">type</label>
                                    <select class="col-8 form-control" v-model="expense.expenseTypeId" required>
                                        <option v-for="(type,index) in add_expense.expense_types" :key="index" :value="type.id">
                                            {{type.name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">location</label>
                                    <select class="col-8 form-control" v-model="expense.location_id" required>
                                        <option v-for="(location,index) in add_expense.locations" :key="index" :value="location.id">
                                            {{location.name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">narration</label>
                                    <textarea  rows="3" class="col-8 form-control" v-model="expense.narration"></textarea>
                                </div>
                        </div>
                        <div class="modal-footer">                            
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-success"
                                @click="editExpense()">                                                        
                                Edit expense
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="add_expense.adding"></span>
                            </button>
                        </div>
                    </form>                
                    </div>
                </div>
                </div>
        </section>
    </div>
</template>
<script>
    export default {
        name: 'expenses',
        props: {
            msg: String
        },
        data(){
            return{
                search:null,
                expenses:null,
                //expense type
                expense_types: null,
                expense_type_name: null,
                adding_expense_type: false,
                //date
                date_range:0,
                from_date: null,
                to_date: null,
                //expense in view
                expense:null,
                //add expense
                add_expense:{
                    date: null,
                    amount:null,
                    type:null,
                    location:null,
                    narration: null,
                    //state:
                    adding:false,
                    //expense types:
                    expense_types:null,
                    //location
                    locations:null
                }
            }
        },
        mounted(){
            this.from_date = this.$moment().subtract(this.date_range, 'days').format('YYYY-MM-DD')
            this.to_date = this.$moment().format('YYYY-MM-DD')            
            this.getExpenseTypes()
            this.getExpenses()            
            this.getLocations()
            //set "add expense date" to today
            this.add_expense.date = this.$moment().format('YYYY-MM-DD')  
            document.getElementById('addExpenseForm').submit((e)=>{
                e.preventDefault()
            }) 

        },
        computed:{     
            account_switched(){
                return this.$store.state.account_switch_count
            }
        },
        watch:{
            account_switched: function(){
                this.getExpenses()            
                this.getLocations()
            }, 
            date_range: function(){
                if (this.date_range){
                    this.from_date = this.$moment().subtract(this.date_range, 'days').format('YYYY-MM-DD')
                    this.to_date = this.$moment().format('YYYY-MM-DD')
                    this.getExpenses()
                }
            },
            search:function(){			
                this.$searchTable('ordersTable',this.search)			
            }
        },
        methods:{		
            //get_products
            getExpenses: function(){            
                this.expenses = null
                this.$http({
                    method:'get',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/expenses/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },
                    params:{
                        date0: this.from_date,
                        date1: this.to_date
                    },                    
                }).then((response)=>{
                    this.expenses = response.data
                }).catch((err)=>{
                    this.$emit('alert',err)
                })
            },
            // select expense to edit or view
            selectExpense: function(expense){
                this.expense = expense
            },
            //expense types for when adding
            getExpenseTypes: function(){                            
                this.$http({
                    method:'get',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/expense-types/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },                
                }).then((response)=>{                    
                    this.expense_types = response.data                   
                    this.add_expense.expense_types = response.data
                }).catch((err)=>{
                    this.$emit('alert',err)
                })
            },
            //locations types for when adding
            getLocations: function(){                            
                this.$http({
                    method:'get',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/locations/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },                
                }).then((response)=>{
                    this.add_expense.locations = response.data
                }).catch((err)=>{
                    this.$emit('alert',err)
                })
            },
            //add expense.
            addExpense: function(){
                var is_valid = document.getElementById('addExpenseForm').checkValidity()
                if(is_valid){
                    this.add_expense.adding = true
                    this.$http({
                        method:'post',
                        url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/expense/`,
                        headers:{
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        },   
                        data:{
                            date: this.add_expense.date,
                            amount: this.add_expense.amount,
                            location_id: this.add_expense.location,
                            narration: this.add_expense.narration,
                            expenseTypeId: this.add_expense.type
                        }             
                    }).then(()=>{
                        this.add_expense.adding = false
                        document.getElementById('closeAddExpenseModal').click()
                        this.getExpenses()
                    }).catch((err)=>{
                        this.add_expense.adding = false
                        alert(err)
                    })                
                }
            },
            //add expense.
            addExpenseType: function(){
                this.adding_expense_type = true            
                this.$http({
                    method:'post',
                    url: this.$API_BASE_URL + `/HJYBCFRB/v1/expense-type`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },   
                    data:{
                        id: this.$randID(),
                        name: this.expense_type_name,
                    }             
                }).then(()=>{
                    this.adding_expense_type = false
                    document.getElementById('closeAddExpenseTypeModal').click()
                    this.getExpenseTypes()
                }).catch((err)=>{
                    this.adding_expense_type = false
                    alert(err)
                })                                
            },
            //edit expense   
            editExpense: function(){
                var is_valid = document.getElementById('editExpenseForm').checkValidity()
                if(is_valid){
                    this.add_expense.adding = true
                    this.$http({
                        method:'patch',
                        url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/expense/`,
                        headers:{
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        },   
                        data:this.expense          
                    }).then(()=>{
                        this.add_expense.adding = false
                        document.getElementById('closeAddExpenseModal').click()
                        this.getExpenses()
                    }).catch((err)=>{
                        this.add_expense.adding = false
                        alert(err)
                    })                
                }
            },
            //delete expense type.           
            deleteExpenseType: function(expense_type){
                var confirmed = confirm(`Do you want to delete ${expense_type.name} from system ?`);
                if (confirmed) {
                    this.$http({
                        method:'delete',				
                        url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/expense-type/${expense_type.id}/`,
                        headers:{
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        },            
                    }).then(()=>{
                        this.getExpenseTypes()
                    }).catch((err)=>{
                        alert(err)
                    })
                }
            },            
            // delete expense
            deleteExpense: function(expense){
                var confirmed = confirm(`Do you want to delete ${expense.narration} from system ?`);
                if (confirmed) {
                    this.$http({
                        method:'delete',				
                        url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/expense/${expense.id}/`,
                        headers:{
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        },            
                    }).then(()=>{
                        this.getExpenses()
                    }).catch((err)=>{
                        alert(err)
                    })
                }
            }

        }
    }
</script>